import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let Group = class Group extends Vue {
  get marginClass() {
    return this.isMargin ? 'lc-am-group-margin' : '';
  }
  get paddingClass() {
    return this.isPadding ? 'lc-am-group-content-padding' : '';
  }
  get borderClass() {
    return this.isBorder ? 'lc-am-group-border' : '';
  }
  get dividerClass() {
    return this.headerLine ? 'lc-am-group-header-divider' : '';
  }
};
Group.componentName = 'Group';
__decorate([Prop({
  type: Boolean,
  default: true
})], Group.prototype, "showHeader", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], Group.prototype, "isMargin", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], Group.prototype, "isPadding", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], Group.prototype, "isBorder", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], Group.prototype, "headerLine", void 0);
__decorate([Prop({
  type: String,
  default: () => {
    return window.lowcode.i18n.get('apaas_amui_group_title', '分组');
  }
})], Group.prototype, "title", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], Group.prototype, "icon", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], Group.prototype, "tooltip", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], Group.prototype, "subTitle", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], Group.prototype, "extra", void 0);
Group = __decorate([Component({
  name: 'Group'
})], Group);
export default Group;